<mat-card class="mat-elevation-z8">
    <form [formGroup]="union_office_register_form">
        <!-- user details -->
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label for="exampleFormControlSelect1">Union  <i class="material-icons"
                        style="color: red;font-size: 14px;">star</i></label>
                    <select class="form-control dropdown_box" formControlName='union_id'>
                        <option *ngFor="let union of unions" [value]="union['id']">{{union['name']}}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col">
                <div class="form-group">
                    <label>Name  <i class="material-icons"
                        style="color: red;font-size: 14px;">star</i></label>
                    <input type="text" class="form-control code_box" formControlName='name'>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label>Street </label>
                    <input type="text" class="form-control code_box" formControlName='street'>
                </div>
            </div>
            <div class="col">
                <div class="form-group">
                    <label>address</label>
                    <input type="textarea" class="form-control code_box" formControlName='address'>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label for="exampleFormControlSelect1">Taluk  <i class="material-icons"
                        style="color: red;font-size: 14px;">star</i></label>
                    <select class="form-control dropdown_box" formControlName='taluk_id'>
                        <option *ngFor="let taluk of taluks" [value]="taluk['id']">{{taluk['name']}}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col">
                <div class="form-group">
                    <label for="exampleFormControlSelect1">District  <i class="material-icons"
                        style="color: red;font-size: 14px;">star</i></label>
                    <select class="form-control dropdown_box" formControlName='district_id'>
                        <option *ngFor="let district of districts" [value]="district['id']">{{district['name']}}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col">
                <div class="form-group">
                    <label for="exampleFormControlSelect1">State  <i class="material-icons"
                        style="color: red;font-size: 14px;">star</i></label>
                    <select class="form-control dropdown_box" formControlName='state_id'>
                        <option *ngFor="let state of states" [value]="state['id']">{{state['name']}}
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <div class="row">

            <div class="col">
                <div class="form-group">
                    <label>Mobile  <i class="material-icons"
                        style="color: red;font-size: 14px;">star</i></label>
                    <input type="number" class="form-control code_box" formControlName='mobile'>
                    <div style="font-style: italic; font-size: small"
                    [ngStyle]="{'color': union_office_register_form.controls.mobile.valid? 'green': 'red'}"
                    *ngIf="union_office_register_form.controls.mobile.errors !== null">
                    {{ union_office_register_form.controls.mobile.errors['error']}}
                </div>
                </div>
            </div>
            <div class="col">
                <div class="form-group">
                    <label>Alternative mobile</label>
                    <input type="number" class="form-control code_box" formControlName='alternate_mobile'>
                    <div style="font-style: italic; font-size: small"
                    [ngStyle]="{'color': union_office_register_form.controls.alternate_mobile.valid? 'green': 'red'}"
                    *ngIf="union_office_register_form.controls.alternate_mobile.errors !== null">
                    {{ union_office_register_form.controls.alternate_mobile.errors['error']}}
                </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label>Phone</label>
                    <input type="number" class="form-control code_box" formControlName='phone'>
                </div>
            </div>
        </div>
        <button style="margin-left: 40%;" mat-raised-button color="primary" [disabled]="!union_office_register_form.valid"
        (click)="registerUnionOffice()">{{action}}</button>
    </form>
</mat-card>
